import * as React from "react"
import { Container, Modal, Row, Col, Button, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import ConfirmationModal from "../ConfirmationModal"
import CompanyUserCode, { CreateEmptyCompanyUserCode, CopyCompanyUserCode, CopyCompanyUserCodes } from "../../api/Administration/Model/ComapnyUserCode"
import { SaveCompanyUserCode } from "../../api/Administration/CompanyUserCodes"

interface CompanyUserCodeModalProps {
  show: boolean
  selectedUserCode: CompanyUserCode
  onSave: (companyUserCode: CompanyUserCode) => void
  onClose: () => void
}

interface CompanyUserCodeModalState {
  code: string
  description: string
  saving: boolean
  showConfirmUpdate: false
}

export default class CompanyUserCodeModal extends React.PureComponent<CompanyUserCodeModalProps, {}> {
  state: CompanyUserCodeModalState = { code: this.props.selectedUserCode.Code, description: this.props.selectedUserCode.Description, saving: false, showConfirmUpdate: false }
  subscription?: Subscription

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  handleSave = () => {
    const companyUserCode = this.props.selectedUserCode
    const isEditMode = companyUserCode.UserDefinedCodeID > 0
    if (isEditMode) {
      this.setState({ showConfirmUpdate: true })
    }
    else {
      this.handleConfirmSave()
    }
  }
  handleConfirmSave = () => {

    this.setState({ saving: true, showConfirmUpdate: false })
    this.subscription && this.subscription.unsubscribe()
    const selectedUserCode = CopyCompanyUserCode(this.props.selectedUserCode)
    selectedUserCode.Code = this.state.code
    selectedUserCode.Description = this.state.description
    this.subscription = SaveCompanyUserCode(selectedUserCode).subscribe(
      (data: CompanyUserCode) => {
        this.setState({ saving: false })
        if (data.ErrorMessage === "") {
          toast.success("Record saved successfully")
          this.props.onSave(data)
        }
        else {
          toast.error(data.ErrorMessage)
        }
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }

  handleConfirmClose = () => {
    this.setState({ showConfirmUpdate: false })
  }

  render() {
    const companyUserCode = this.props.selectedUserCode
    const code = this.state.code
    const description = this.state.description
    const disableEditCode = companyUserCode.UserDefinedCodeID > 0
    const title = (companyUserCode.UserDefinedCodeID > 0) ? "Edit Code: " + companyUserCode.UserFieldType : "Add Code: " + companyUserCode.UserFieldType
    const showConfirmUpdate = this.state.showConfirmUpdate
    return (
      <>
        {disableEditCode &&
          <ConfirmationModal show={showConfirmUpdate}
            title=""
            textTitle=""
            text="All historical records will use the new code change!  Do you want to continue?"
            showImage={false}
            cancelButtonText="No"
            confirmButtonText="Yes"
            onConfirm={() => this.handleConfirmSave()}
            onHide={() => this.handleConfirmClose()} />
        }

        <ConfirmationModal show={this.props.show}
          title={title}
          confirmButtonText="Save"
          onConfirm={this.handleSave}
          onHide={() => this.props.onClose()}
          size="lg"
          disableConfirmButton={(this.state.code.trim().length === 0) || (this.state.description.trim().length === 0)}
          spinConfirmButton={this.state.saving}
          disableConfirmOnSpin={true}>
          <Form>
            <Form.Row className="form-group required">
              <Form.Label column lg={3} htmlFor="company_user_code_code">Code:</Form.Label>
              <Col lg={9}>
                <Form.Control
                  id="company_user_code_code"
                  type="text"
                  disabled={disableEditCode}
                  value={code}
                  onChange={e => this.setState({ code: e.target.value })}
                />
              </Col>
            </Form.Row>
            <Form.Row className="form-group required">
              <Form.Label column lg={3} htmlFor="company_user_code_description">Name:</Form.Label>
              <Col lg={9}>
                <Form.Control
                  id="company_user_code_description"
                  type="text"
                  value={description}
                  onChange={e => this.setState({ description: e.target.value })}
                />
              </Col>
            </Form.Row>
          </Form>
        </ConfirmationModal>
      </>
    )
  }
}